
import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import Services from '../pages/services/page';
import About from '../pages/about/page';
import NotFound from '../pages/NotFound';
import Process from '../pages/process/page';
import Contact from '../pages/contact/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/services',
    element: <Services />
  },
  {
    path: '/about',
    element: <About />
  },
  {
    path: '*',
    element: <NotFound />
  },
  {
    path: '/process',
    element: <Process />
  },
  {
    path: '/contact',
    element: <Contact />
  }
];

export default routes;
